export default function InitialsLogo({ initials = "EX" }) {
  return <div className="initials-logo">{initials}</div>;
}
